import { Container } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import CreateGuiVersionForm from 'components/CreateGuiVersionForm/CreateGuiVersionForm';
import PageHeader from 'components/PageHeader/PageHeader';

export default function CreateGuiVersionPage() {
  const { t } = useTranslation();
  const { id } = useParams();
  return (
    <Container>
      <PageHeader
        hasBackButton
        hasButton={false}
        title={
          id
            ? t('createGuiVersionPage.titleModify')
            : t('createGuiVersionPage.titleCreate')
        }
      />
      <CreateGuiVersionForm />
    </Container>
  );
}